<template>
  <section>
    <div class="container">
      <header class="circleHeader" :style="success ? { marginBottom: '70px' } : ''">
        <h2>{{ contact.title }}</h2>
      </header>
      <div class="content" v-html="contact.content"></div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'contact',
  props: ['contact']
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
  @import ../../assets/styles/colors
  @import ../../assets/styles/mixins
  $sectionColor: $yellow

  section
    background: $sectionColor
    padding: 50px 30px
    +tablet
      padding-top: 105px
      padding-bottom: 165px
    .container
      +tablet
        h4
          font-size: 20px
          font-weight: bold
        h2
          font-size: 36px
          font-weight: bold
          line-height: 50px
      a
        color: inherit
        border-bottom: 2px solid
        &:hover
          border-color: #fff
    .content
      p, ul
        font-size: 18px
        line-height: 1.75
        +tablet
          font-size: 22px
          line-height: 40px    
    .circleHeader
      &:before
        background: white
    .bigForm
      margin-top: 88px
      margin-bottom: 136px
      .submitBtn
        background: $yellow
      .textarea
        +tablet
          min-height: 360px
</style>



// WEBPACK FOOTER //
// Contact.vue?1efe4e84